import { Suspense } from "react";
import { ToastContainer } from "react-toastify";
import PrivateRoutes from "./routes/PrivateRoutes";
import PublicRoutes from "./routes/PublicRoutes";
import { useSelector } from "react-redux";

function App() {
  const storedToken = useSelector((state: any) => {
    return state?.adminLoginSlice?.accessToken;
  });

  return (
    <>
      <Suspense fallback="Loading...">
        {!!storedToken ? <PrivateRoutes /> : <PublicRoutes />}
        <ToastContainer />
      </Suspense>
    </>
  );
}

export default App;
